export enum CookieKey {
  NoticeAcknowledged = 'cookies_notice_acknowledged',
}